import { CnCheckboxGroup, CnComplexCheckboxGroup, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import { handleSelectDataSource, handleSelectRequestConfig, } from '@/common/util/util';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { forwardRef } from 'react';
import isPlainObject from 'lodash/isPlainObject';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.filter,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'CheckboxGroup',
    component: (props) => {
        const { extra, ...rest } = props || {};
        const { type } = extra || {};
        if (type === 'complex') {
            return <CnComplexCheckboxGroup {...rest}/>;
        }
        return <CnCheckboxGroup {...rest}/>;
    },
    formComponent: forwardRef((props, ref) => {
        const { extra, ...rest } = props || {};
        const { type } = extra || {};
        if (type === 'complex') {
            return <formComponentMap.CnComplexCheckboxGroup {...rest} ref={ref}/>;
        }
        return <formComponentMap.CnCheckboxGroup {...rest} ref={ref}/>;
    }),
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state } = config;
        const tempProps = formItem?.['x-component-props'];
        if (isPlainObject(tempProps)) {
            const { extra } = tempProps;
            const { direction } = extra || {};
            if (direction) {
                tempProps.direction = direction;
            }
        }
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
            handleDynamicUrl: true,
        });
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
            recordDataSource: formValue,
        });
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        handleSelectRequestConfig(config);
        handleSelectDataSource(config);
    },
};
